import { useState, useEffect } from 'react'
import api from '../../services/api'
import toast from 'react-hot-toast'

export default function Campanas() {
  const [campanas, setCampanas] = useState([])
  const [sesiones, setSesiones] = useState([])
  const [tags, setTags] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [form, setForm] = useState({
    nombre: '', sesionId: '', contenido: '',
    filtros: { tags: [] },
    delayMinSeg: 5, delayMaxSeg: 15,
  })
  const [preview, setPreview] = useState(null)

  const cargar = async () => {
    const { data } = await api.get('/campanas')
    setCampanas(data)
  }
  useEffect(() => {
    cargar()
    api.get('/sesiones').then(r => { const arr = Array.isArray(r.data) ? r.data : r.data.sesiones; setSesiones(arr.filter(s => s.status === 'conectado')) })
    api.get('/contactos/tags/all').then(r => setTags(r.data))
  }, [])

  const previsualizar = async () => {
    const { data } = await api.post('/campanas/preview', { filtros: form.filtros })
    setPreview(data)
  }

  const crear = async (e) => {
    e.preventDefault()
    try {
      await api.post('/campanas', form)
      toast.success('Campaña creada como borrador')
      setShowModal(false)
      setForm({ nombre: '', sesionId: '', contenido: '', filtros: { tags: [] }, delayMinSeg: 5, delayMaxSeg: 15 })
      cargar()
    } catch (e) {
      toast.error(e.response?.data?.error || 'Error')
    }
  }

  const iniciar = async (id) => {
    if (!window.confirm('¿Iniciar el envío de la campaña? Esta acción no se puede deshacer.')) return
    try {
      const { data } = await api.post(`/campanas/${id}/iniciar`)
      toast.success(`Enviando a ${data.totalContactos} contactos`)
      cargar()
    } catch (e) {
      toast.error(e.response?.data?.error || 'Error')
    }
  }

  const pausar = async (id) => { await api.post(`/campanas/${id}/pausar`); cargar() }
  const cancelar = async (id) => { await api.post(`/campanas/${id}/cancelar`); cargar() }

  const estadoColor = { borrador: '', programada: 'badge-info', enviando: 'badge-warning', completada: 'badge-success', pausada: 'badge-warning', cancelada: 'badge-danger', fallida: 'badge-danger' }

  return (
    <div className="page">
      <div className="flex justify-between items-center" style={{ marginBottom: 18 }}>
        <h1 className="text-2xl font-bold">📢 Campañas masivas</h1>
        <button className="btn btn-primary" onClick={() => setShowModal(true)}>+ Nueva campaña</button>
      </div>

      <div className="card" style={{ padding: 0 }}>
        <table className="table table-card">
          <thead>
            <tr><th>Nombre</th><th>Estado</th><th>Enviados</th><th>Tasa éxito</th><th>Creada</th><th></th></tr>
          </thead>
          <tbody>
            {campanas.map(c => {
              const tasa = c.totalContactos ? Math.round((c.totalEnviados / c.totalContactos) * 100) : 0
              return (
                <tr key={c.id}>
                  <td data-label="Nombre"><div className="font-semibold">{c.nombre}</div></td>
                  <td data-label="Estado"><span className={`badge ${estadoColor[c.estado] || ''}`}>{c.estado}</span></td>
                  <td data-label="Enviados">{c.totalEnviados} / {c.totalContactos}</td>
                  <td data-label="Tasa">{tasa}%</td>
                  <td data-label="Creada">{new Date(c.createdAt).toLocaleDateString()}</td>
                  <td>
                    {c.estado === 'borrador' && <button className="btn btn-sm btn-primary" onClick={() => iniciar(c.id)}>▶ Iniciar</button>}
                    {c.estado === 'enviando' && <button className="btn btn-sm" onClick={() => pausar(c.id)}>⏸ Pausar</button>}
                    {['enviando', 'pausada'].includes(c.estado) && <button className="btn btn-sm btn-danger" onClick={() => cancelar(c.id)}>✕</button>}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
        {campanas.length === 0 && <div className="empty-state">Aún no tienes campañas</div>}
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal modal-lg" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-title">Nueva campaña masiva</span>
              <button className="btn btn-ghost btn-icon" onClick={() => setShowModal(false)}>✕</button>
            </div>
            <form onSubmit={crear}>
              <div className="modal-body">
                <div className="form-group">
                  <label className="form-label">Nombre de la campaña</label>
                  <input className="input" required value={form.nombre} onChange={e => setForm({...form, nombre: e.target.value})} placeholder="Black Friday 2026" />
                </div>

                <div className="form-group">
                  <label className="form-label">Enviar desde el número</label>
                  <select className="select" required value={form.sesionId} onChange={e => setForm({...form, sesionId: e.target.value})}>
                    <option value="">-- Seleccionar --</option>
                    {sesiones.map(s => <option key={s.id} value={s.id}>{s.nombre} (+{s.telefono})</option>)}
                  </select>
                </div>

                <div className="form-group">
                  <label className="form-label">Mensaje (usa {`{{nombre}}`} para personalizar)</label>
                  <textarea className="textarea" rows={5} required value={form.contenido} onChange={e => setForm({...form, contenido: e.target.value})}
                    placeholder="Hola {{nombre}}, tenemos una oferta especial..." />
                  <div className="form-hint">Variables: {`{{nombre}}, {{telefono}}, {{email}}`}</div>
                </div>

                <div className="form-group">
                  <label className="form-label">Audiencia (etiquetas)</label>
                  <div className="flex gap-2" style={{ flexWrap: 'wrap' }}>
                    {tags.map(t => (
                      <button type="button" key={t.id}
                        className={`badge ${form.filtros.tags.includes(t.nombre) ? 'badge-primary' : ''}`}
                        style={{ cursor: 'pointer', border: '1px solid var(--border)' }}
                        onClick={() => setForm({...form, filtros: { ...form.filtros, tags: form.filtros.tags.includes(t.nombre) ? form.filtros.tags.filter(x => x !== t.nombre) : [...form.filtros.tags, t.nombre] }})}>
                        {t.nombre}
                      </button>
                    ))}
                  </div>
                  <div className="form-hint">Sin etiquetas = todos los contactos. Solo se envía a quienes permiten campañas.</div>
                  <button type="button" className="btn btn-sm btn-outline" style={{ marginTop: 8 }} onClick={previsualizar}>👁️ Previsualizar audiencia</button>
                  {preview && <div className="text-sm" style={{ marginTop: 8 }}>📊 <strong>{preview.total}</strong> contactos coinciden</div>}
                </div>

                <div className="flex gap-3 delay-inputs">
                  <div className="form-group flex-1">
                    <label className="form-label">Delay mín (seg)</label>
                    <input type="number" className="input" min="2" value={form.delayMinSeg} onChange={e => setForm({...form, delayMinSeg: parseInt(e.target.value)})} />
                  </div>
                  <div className="form-group flex-1">
                    <label className="form-label">Delay máx (seg)</label>
                    <input type="number" className="input" min="3" value={form.delayMaxSeg} onChange={e => setForm({...form, delayMaxSeg: parseInt(e.target.value)})} />
                  </div>
                </div>
                <div className="form-hint">⚠️ Delays bajos (&lt;5s) aumentan riesgo de baneo</div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn" onClick={() => setShowModal(false)}>Cancelar</button>
                <button className="btn btn-primary">Crear borrador</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}
